import { useAnalytics } from '@blueshift-ui/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function usePageViewTracking() {
  const analytics = useAnalytics();
  const location = useLocation();

  /**
   * We need a dependency on location to trigger the effect whenever the page path changes. The
   * reason it's not included in the call to analytics.page is that the library automatically
   * includes the information internally.
   * @see https://segment.com/docs/connections/spec/page/#properties Note at the bottom of the section
   * for more information.
   *
   * Note: In analytics.js, Segment automatically sends the following properties: title, path, url,
   * referrer, and search.
   */
  useEffect(() => {
    analytics.page('client-account-ui');
  }, [analytics, location]);
}

export default usePageViewTracking;
